import { render, staticRenderFns } from "./AtomSimpleButton.vue?vue&type=template&id=32e3038c&"
import script from "./AtomSimpleButton.vue?vue&type=script&lang=js&"
export * from "./AtomSimpleButton.vue?vue&type=script&lang=js&"
import style0 from "./AtomSimpleButton.vue?vue&type=style&index=0&id=32e3038c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports